import { httpsCallable } from 'firebase/functions';
import { collection, doc, getDoc, getDocs } from 'firebase/firestore';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import { Collections, db, functions } from '../../utils/firebase.config';
import { converterOf } from '../../utils/firebase.utils';
import EntityShop, { Shop } from '../../entities/shop.entity';
import FetchError from '../../errors/fetch.error';
import CreateShopResource from './resources/create-shop.resource';
import UpdateShopResource from './resources/update-shop.resource';

export type UpdateShop = Partial<Shop> & { id: string };

export function useShops() {
  const shopsCollection = collection(db, Collections.Shops).withConverter(converterOf(EntityShop));

  const create = async(input: Omit<Shop, 'id'>): Promise<Shop> => {
    const insertShop = httpsCallable<unknown, Shop>(
      functions,
      'insertShop'
    );

    const resource = new CreateShopResource(input);
    const result = await insertShop(instanceToPlain(resource)).catch((err) => { console.log(err); throw err;});
    return plainToInstance(Shop, result.data);
  };

  const fetchAll = async (): Promise<EntityShop[]> => {
    const response = await getDocs<EntityShop>(shopsCollection);

    return response.docs.map((shop) => shop.data());
  };

  const fetchById = async (id: string): Promise<EntityShop> => {
    const personDoc = doc(shopsCollection, id);
    const resource = await getDoc(personDoc);
    const data = resource.data();

    if (!data) {
      throw new FetchError({ trace: 'fetchById', message: `Não foi possível carregar a loja com o id: ${id}` });
    }

    return data;
  };

  const update = async (input: Partial<Shop> & { id: string }): Promise<void> => {
    const updateShop = httpsCallable(functions, 'updateShop');
    const resource = new UpdateShopResource(input);
    await updateShop(instanceToPlain(resource));
  };

  return { fetchAll, fetchById, create, update };
}

export default useShops;
